import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { AllocationViewEndpoint } from '../constants/allocation-view-endpoint';
import { AllocationViewListSearchCriteria, AllocationViewListResponse, DriverViewList } from '../models';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { RequestHeader } from '../../../../constants/headers';
import { TruckStatus, UliStatus } from '../../../../../common/constants';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewListService {
  constructor(private http: WrapperHttpService) {}

  getAllocationViewList({
    size,
    page,
    hubId,
    ...filters
  }: AllocationViewListSearchCriteria): Observable<AllocationViewListResponse> {
    const url = `${API_URL}${AllocationViewEndpoint.Base}/${hubId}${AllocationViewEndpoint.Uli}`;
    return this.http.withLoading().post<AllocationViewListResponse>(url, { page, size, filters });
  }

  getAllocationDriverViewList(payload: {
    uliId: number;
    endDate: number;
    startDate: number;
  }): Observable<DriverViewList> {
    let params = new HttpParams();
    for (const property in payload) {
      if (property in payload) {
        params = params.append('uliId', payload[property].uliId);

        params = params.append('endDate', payload[property].endDate);
        params = params.append('startDate', payload[property].startDate);
      }
    }

    const url =
      `${API_URL}${AllocationViewEndpoint.Base}${AllocationViewEndpoint.Public}` +
      '/' +
      params.get('uliId') +
      `${AllocationViewEndpoint.DriverView}`;

    return this.http.withLoading().post<DriverViewList>(
      url,
      {
        page: 0,
        size: 1000,
        filters: {
          noDock: false,
          withoutTruckPlate: false,
          carrierId: null,
          carrierNumber: null,
          loadNumbers: [],
          transportOrderNumbers: [],
          type: [],
          truckPlate: null,
          party: null,
          uli: null,
          uliStatuses: [
            UliStatus.Registered,
            UliStatus.CalledToDock,
            UliStatus.CalledToWaitingArea,
            UliStatus.Processed,
            UliStatus.Loading,
            UliStatus.Unloading,
          ],
          uliOrigin: [],
          truckStatuses: [
            TruckStatus.CalledToDock,
            TruckStatus.Registered,
            TruckStatus.CalledToArrivalSecurity,
            TruckStatus.CalledToWaitingArea,
            TruckStatus.WaitingArea,
          ],
          slotId: null,
          compartmentDockStructure: { compartments: [] },
          registrationId: null,
          timeFrame: {
            start: params.get('startDate'),
            end: params.get('endDate'),
          },
        },
      },
      {
        headers: new HttpHeaders({
          [RequestHeader.SkipInterceptor]: '',
        }),
      },
    );
  }
}
